import request from '@/utils/request2';
export function questionnaireExamineListData(data) {
  return request.post('admin/audit/questionnaire-list', data);
}

// 审核进度
export function auditSchedule(data) {
  return request.post('admin/audit/schedule', data);
}

// 审核详情
export function auditDetail(data) {
  return request.post('admin/audit/detail', data);
  // .then(res => {
  // console.log(res.initialNodeInfo.claimsDocument);
  // if (res.initialNodeInfo.claimsTypeId) {
  //   res.initialNodeInfo.claimsDocument.map(i2 => {
  //     console.log(i2.documentUrl);
  //     let arr = [];
  //     i2.documentUrl.map((i, index) => {
  //       let name = i.substring(i.lastIndexOf('/') + 1, i.lastIndexOf('.'));
  //       let format = i.substring(i.lastIndexOf('.')).toLowerCase();
  //       let obj = {
  //         status: 'done',
  //         uid: index + 1,
  //         url: i,
  //         format: format.slice(1),
  //         name: name + format
  //       };
  //       console.log(obj);
  //       arr.push(obj);
  //     });
  //     i2.documentUrl = arr;
  //     return i2;
  //   });
  // }
  // return res;
  // });
}
// 审核操作
export function auditOperate(data) {
  return request.post('admin/audit/operate', data);
}